import type { GenUiKey } from './i18n.js';

/** Chaves do produtor (`POLICY_RULE_TITLES` do modal-session) → i18n. Chave fora
 *  da tabela (produtor mais novo) cai no `title` do wire, que é o fallback pt-BR. */
export const FLIGHT_POLICY_RULE_KEYS: Readonly<Record<string, GenUiKey>> = {
  advance: 'flight.policyRule.advance',
  allowedClass: 'flight.policyRule.allowedClass',
  baggage: 'flight.policyRule.baggage',
  baggageOnlyAboveTripLength: 'flight.policyRule.baggageOnlyAboveTripLength',
  baggageOnlyOnMultipleSegments: 'flight.policyRule.baggageOnlyOnMultipleSegments',
  bookingWindow: 'flight.policyRule.bookingWindow',
  bookingWindowInternational: 'flight.policyRule.bookingWindowInternational',
  cheapestPrice: 'flight.policyRule.cheapestPrice',
  cheapestPriceFastest: 'flight.policyRule.cheapestPriceFastest',
  cheapestPriceNonStop: 'flight.policyRule.cheapestPriceNonStop',
  cheapestPricePeriod: 'flight.policyRule.cheapestPricePeriod',
  class: 'flight.policyRule.class',
  classLimits: 'flight.policyRule.classLimits',
  price: 'flight.policyRule.price',
  withinPolicy: 'flight.policyRule.withinPolicy',
  withinPolitics: 'flight.policyRule.withinPolitics',
  policyProfile: 'flight.policyRule.policyProfile',
  policyProfileUnresolved: 'flight.policyRule.policyProfileUnresolved',
  companyGuidance: 'flight.policyRule.companyGuidance',
};
